export const getPiemontData = () => ({
  name: "Piémont",
  country: "Italie",
  description: "Le Piémont est la région des vins nobles d'Italie, produisant les prestigieux Barolo et Barbaresco, ainsi que les vins effervescents Asti.",
  type: "region",
  mapAreas: [
    { region: "Piémont", x: 47, y: 38, color: "#4B164C", size: 5 }
  ],
  statistics: {
    totalArea: "46,000 ha",
    production: "2,800,000 hl",
    wineries: "800+ domaines",
    villages: "20+ communes",
    exportPercentage: "75%"
  },
  characteristics: {
    climate: "Climat continental, hivers froids, étés chauds, brouillards d'automne",
    soil: "Sols calcaires, marneux, argileux",
    viticulture: "Vendanges manuelles, pergolas traditionnelles, DOCG strictes"
  },
  wineStyles: {
    red: "Rouges puissants et tanniques (Barolo, Barbaresco, Barbera)",
    white: "Blancs secs et aromatiques (Gavi, Roero Arneis)",
    sparkling: "Asti Spumante, Moscato d'Asti, méthode traditionnelle"
  },
  history: "Le Piémont produit des vins depuis l'Antiquité romaine. Le Barolo était le vin des rois d'Italie au XIXe siècle.",
  foodPairing: "Truffes blanches, risotto, viandes braisées, fromages affinés, chocolat",
  subregions: {
    "langhe": {
      name: "Langhe",
      area: "8,000 ha",
      percentage: "17.4%",
      description: "Barolo et Barbaresco",
      characteristics: {
        climate: "Climat continental avec brouillards",
        soil: "Sols calcaires et marneux",
        viticulture: "Vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Nebbiolo", "Barbera", "Dolcetto"]
      },
      wineStyles: {
        red: "Rouges puissants et tanniques"
      },
      foodPairing: "Truffes blanches, viandes braisées"
    },
    "monferrato": {
      name: "Monferrato",
      area: "12,000 ha",
      percentage: "26.1%",
      description: "Barbera et Moscato",
      characteristics: {
        climate: "Climat continental tempéré",
        soil: "Sols argileux et calcaires",
        viticulture: "Vendanges mécaniques et manuelles"
      },
      grapeVarieties: {
        red: ["Barbera", "Grignolino"],
        white: ["Moscato"]
      },
      wineStyles: {
        red: "Rouges fruités et souples",
        sparkling: "Moscato d'Asti"
      },
      foodPairing: "Pâtes, risotto, desserts"
    },
    "roero": {
      name: "Roero",
      area: "1,200 ha",
      percentage: "2.6%",
      description: "Arneis et Nebbiolo",
      characteristics: {
        climate: "Climat continental",
        soil: "Sols sableux et argileux",
        viticulture: "Vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Nebbiolo"],
        white: ["Arneis"]
      },
      wineStyles: {
        red: "Rouges élégants",
        white: "Blancs secs et aromatiques"
      },
      foodPairing: "Poissons, fromages frais"
    },
    "gavi": {
      name: "Gavi",
      area: "1,000 ha",
      percentage: "2.2%",
      description: "Cortese di Gavi",
      characteristics: {
        climate: "Climat méditerranéen tempéré",
        soil: "Sols calcaires",
        viticulture: "Vendanges manuelles"
      },
      grapeVarieties: {
        white: ["Cortese"]
      },
      wineStyles: {
        white: "Blancs secs et minéraux"
      },
      foodPairing: "Poissons, fruits de mer, antipasti"
    },
    "asti": {
      name: "Asti",
      area: "9,500 ha",
      percentage: "20.7%",
      description: "Moscato d'Asti",
      characteristics: {
        climate: "Climat continental tempéré",
        soil: "Sols argileux et calcaires",
        viticulture: "Vendanges manuelles"
      },
      grapeVarieties: {
        white: ["Moscato"]
      },
      wineStyles: {
        sparkling: "Asti Spumante, Moscato d'Asti"
      },
      foodPairing: "Desserts, fruits, pâtisseries"
    }
  },
  grapeVarieties: [
    { name: "Nebbiolo", percentage: "15%", description: "Cépage noble du Barolo et Barbaresco" },
    { name: "Barbera", percentage: "35%", description: "Cépage le plus planté" },
    { name: "Dolcetto", percentage: "20%", description: "Vin de consommation quotidienne" },
    { name: "Moscato", percentage: "15%", description: "Vins effervescents et doux" },
    { name: "Cortese", percentage: "8%", description: "Cépage blanc de Gavi" },
    { name: "Autres", percentage: "7%", description: "Cépages mineurs" }
  ]
}); 